module.exports = __webpack_public_path__ + "assets/0dc04bf03e3a6c9ba0389a0345c6e638.png";